// Generated by BUCKLESCRIPT VERSION 2.2.3, PLEASE EDIT WITH CARE
'use strict';

var Css = require("bs-css/lib/js/src/Css.js");
var Seed = require("./seed");
var $$Array = require("bs-platform/lib/js/array.js");
var Block = require("bs-platform/lib/js/block.js");
var Curry = require("bs-platform/lib/js/curry.js");
var Theme = require("./theme");
var React = require("react");
var Js_exn = require("bs-platform/lib/js/js_exn.js");
var Network = require("./network");
var Caml_obj = require("bs-platform/lib/js/caml_obj.js");
var Caml_array = require("bs-platform/lib/js/caml_array.js");
var Caml_int32 = require("bs-platform/lib/js/caml_int32.js");
var Caml_format = require("bs-platform/lib/js/caml_format.js");
var ReasonReact = require("reason-react/lib/js/src/ReasonReact.js");
var Cta_arrowSvg = require("./assets/cta_arrow.svg");
var Info_iconSvg = require("./assets/info_icon.svg");
var Caml_builtin_exceptions = require("bs-platform/lib/js/caml_builtin_exceptions.js");
var Jogging_iconSvg = require("./assets/jogging_icon.svg");

var flexList = Css.style(/* :: */[
      Css.flexDirection(Css.column),
      /* :: */[
        Css.width(/* `percent */[
              -119887163,
              100.0
            ]),
        /* :: */[
          Css.alignItems(Css.center),
          /* [] */0
        ]
      ]
    ]);

var mapElement = Css.style(/* :: */[
      Css.flexDirection(Css.column),
      /* :: */[
        Css.width(/* `percent */[
              -119887163,
              100.0
            ]),
        /* :: */[
          Css.alignItems(Css.center),
          /* [] */0
        ]
      ]
    ]);

var headBox = Css.style(/* :: */[
      Css.position(/* relative */903134412),
      /* :: */[
        Css.flexDirection(Css.column),
        /* :: */[
          Css.width(/* `percent */[
                -119887163,
                100.0
              ]),
          /* :: */[
            Css.alignItems(Css.center),
            /* :: */[
              Css.background(Css.hex("fffafa")),
              /* :: */[
                Css.marginBottom(Css.px(10)),
                /* [] */0
              ]
            ]
          ]
        ]
      ]
    ]);

var contentBox = Css.style(/* :: */[
      Css.flexDirection(Css.column),
      /* :: */[
        Css.width(/* `percent */[
              -119887163,
              100.0
            ]),
        /* :: */[
          Css.boxSizing(/* borderBox */9307263),
          /* :: */[
            Css.alignItems(Css.center),
            /* :: */[
              Css.padding4(Css.px(0), Css.px(12), Css.px(2), Css.px(12)),
              /* [] */0
            ]
          ]
        ]
      ]
    ]);

var infoHeader = Css.style(/* :: */[
      Css.fontSize(Css.px(18)),
      /* :: */[
        Css.margin4(Css.px(18), Css.px(0), Css.px(6), Css.px(0)),
        /* [] */0
      ]
    ]);

var infoHeaderH1 = Css.style(/* :: */[
      Css.margin4(Css.px(18), Css.px(0), Css.px(0), Css.px(0)),
      /* :: */[
        Css.zIndex(2),
        /* [] */0
      ]
    ]);

var infoHeaderH4 = Css.style(/* :: */[
      Css.fontSize(Css.px(18)),
      /* :: */[
        Css.margin4(Css.px(0), Css.px(0), Css.px(6), Css.px(0)),
        /* :: */[
          Css.zIndex(2),
          /* [] */0
        ]
      ]
    ]);

var infoButton = Css.style(/* :: */[
      Css.position(/* absolute */-1013592457),
      /* :: */[
        Css.right(Css.px(12)),
        /* :: */[
          Css.cursor(/* pointer */-786317123),
          /* :: */[
            Css.margin4(Css.px(0), Css.px(0), Css.px(0), Css.px(10)),
            /* [] */0
          ]
        ]
      ]
    ]);

var workoutContainer = Css.style(/* :: */[
      Css.flexDirection(Css.column),
      /* :: */[
        Css.alignItems(Css.center),
        /* :: */[
          Css.width(/* `percent */[
                -119887163,
                100.0
              ]),
          /* :: */[
            Css.margin4(Css.px(0), Css.px(0), Css.px(10), Css.px(0)),
            /* :: */[
              Css.borderTopLeftRadius(Css.px(10)),
              /* :: */[
                Css.borderTopRightRadius(Css.px(10)),
                /* :: */[
                  Css.borderBottomLeftRadius(Css.px(10)),
                  /* :: */[
                    Css.borderBottomRightRadius(Css.px(10)),
                    /* :: */[
                      Css.boxShadow(/* Some */[Css.px(1)], /* Some */[Css.px(2)], /* Some */[Css.px(4)], /* None */0, /* None */0, Css.rgba(244, 44, 123, 0.25)),
                      /* [] */0
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

var workoutHeaderBox = Css.style(/* :: */[
      Css.position(/* relative */903134412),
      /* :: */[
        Css.flexDirection(Css.row),
        /* :: */[
          Css.alignItems(Css.center),
          /* :: */[
            Css.justifyContent(Css.center),
            /* :: */[
              Css.background(Css.hex("FFFAFA")),
              /* :: */[
                Css.borderBottom(Css.px(2), /* solid */12956715, Css.hex("FCEBEC")),
                /* :: */[
                  Css.width(/* `percent */[
                        -119887163,
                        100.0
                      ]),
                  /* :: */[
                    Css.borderTopLeftRadius(Css.px(10)),
                    /* :: */[
                      Css.borderTopRightRadius(Css.px(10)),
                      /* [] */0
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

var workoutHeaderMiddleEl = Css.style(/* :: */[
      Css.flexDirection(Css.column),
      /* :: */[
        Css.alignItems(Css.center),
        /* [] */0
      ]
    ]);

var workoutNameHeader = Css.style(/* :: */[
      Css.lineHeight(1.2),
      /* :: */[
        Css.margin4(Css.px(5), Css.px(48), Css.px(0), Css.px(48)),
        /* [] */0
      ]
    ]);

var pairBox = Css.style(/* :: */[
      Css.fontSize(Css.px(12)),
      /* :: */[
        Css.margin4(Css.px(0), Css.px(8), Css.px(2), Css.px(8)),
        /* [] */0
      ]
    ]);

var initialBodyFrame = Css.style(/* :: */[
      Css.flexDirection(Css.column),
      /* :: */[
        Css.maxWidth(/* `percent */[
              -119887163,
              100.0
            ]),
        /* :: */[
          Css.marginBottom(Css.px(5)),
          /* [] */0
        ]
      ]
    ]);

var initialBodyFrameBox = Css.style(/* :: */[
      Css.flexDirection(Css.column),
      /* :: */[
        Css.maxWidth(/* `percent */[
              -119887163,
              100.0
            ]),
        /* [] */0
      ]
    ]);

var initialBody = Css.style(/* :: */[
      Css.flexDirection(Css.row),
      /* :: */[
        Css.maxWidth(/* `percent */[
              -119887163,
              100.0
            ]),
        /* [] */0
      ]
    ]);

var initialBodyImgContainer = Css.style(/* :: */[
      Css.position(/* relative */903134412),
      /* :: */[
        Css.margin4(Css.px(5), Css.px(3), Css.px(1), Css.px(3)),
        /* :: */[
          Css.padding2(Css.px(0), Css.px(0)),
          /* :: */[
            Css.minWidth(Css.px(0)),
            /* :: */[
              Css.alignItems(/* center */98248149),
              /* [] */0
            ]
          ]
        ]
      ]
    ]);

var hiddenImgContainer = Css.style(/* :: */[
      Css.visibility(/* hidden */-862584982),
      /* :: */[
        Css.height(Css.px(0)),
        /* [] */0
      ]
    ]);

var imgType = Css.style(/* :: */[
      Css.position(/* absolute */-1013592457),
      /* :: */[
        Css.top(Css.px(0)),
        /* :: */[
          Css.left(Css.px(4)),
          /* :: */[
            Css.color(/* `hex */[
                  5194459,
                  "E02C7B"
                ]),
            /* :: */[
              Css.fontWeight(700),
              /* :: */[
                Css.fontSize(Css.px(14)),
                /* [] */0
              ]
            ]
          ]
        ]
      ]
    ]);

var initialBodyImg = Css.style(/* :: */[
      Css.maxWidth(/* `percent */[
            -119887163,
            100.0
          ]),
      /* [] */0
    ]);

var horizonBox = Css.style(/* :: */[
      Css.flexDirection(Css.row),
      /* :: */[
        Css.alignItems(Css.center),
        /* :: */[
          Css.margin4(Css.px(0), Css.px(0), Css.px(0), Css.px(0)),
          /* :: */[
            Css.justifyContent(Css.spaceAround),
            /* :: */[
              Css.width(/* `percent */[
                    -119887163,
                    100.0
                  ]),
              /* :: */[
                Css.background(Css.hex("00")),
                /* :: */[
                  Css.borderBottomLeftRadius(Css.px(10)),
                  /* :: */[
                    Css.borderBottomRightRadius(Css.px(10)),
                    /* :: */[
                      Css.padding2(Css.px(8), Css.px(0)),
                      /* [] */0
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

function horizonBoxEl(el, value) {
  var match = Caml_obj.caml_equal(el, value);
  return Css.style(/* :: */[
              Css.display(Css.flexBox),
              /* :: */[
                Css.flexGrow(1),
                /* :: */[
                  match !== 0 ? Css.background(Css.lightgreen) : Css.background(Css.lightblue),
                  /* :: */[
                    Css.margin4(Css.px(0), Css.px(10), Css.px(0), Css.px(10)),
                    /* :: */[
                      Css.fontSize(Css.px(24)),
                      /* :: */[
                        Css.minHeight(Css.px(40)),
                        /* :: */[
                          Css.maxWidth(Css.px(100)),
                          /* :: */[
                            Css.fontWeight(700),
                            /* :: */[
                              Css.cursor(/* pointer */-786317123),
                              /* :: */[
                                Css.justifyContent(Css.center),
                                /* :: */[
                                  Css.alignItems(Css.center),
                                  /* [] */0
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]);
}

function smallerGreenSecondaryButton() {
  return Css.style(/* :: */[
              Css.minWidth(Css.px(80)),
              /* :: */[
                Css.maxWidth(Css.px(100)),
                /* :: */[
                  Css.width(/* `percent */[
                        -119887163,
                        100.0
                      ]),
                  /* :: */[
                    Css.height(Css.px(30)),
                    /* :: */[
                      Css.margin4(Css.px(2), Css.px(0), Css.px(2), Css.px(0)),
                      Theme.greenSecondaryButtonRaw
                    ]
                  ]
                ]
              ]
            ]);
}

function smallerRedSecondaryButton() {
  return Css.style(/* :: */[
              Css.minWidth(Css.px(80)),
              /* :: */[
                Css.maxWidth(Css.px(100)),
                /* :: */[
                  Css.width(/* `percent */[
                        -119887163,
                        100.0
                      ]),
                  /* :: */[
                    Css.height(Css.px(30)),
                    /* :: */[
                      Css.color(/* `hex */[
                            5194459,
                            "FFBFC2"
                          ]),
                      /* :: */[
                        Css.margin4(Css.px(2), Css.px(0), Css.px(2), Css.px(0)),
                        /* :: */[
                          Css.border(Css.px(1), /* solid */12956715, Css.rgba(255, 191, 194, 0.5)),
                          Theme.redButtonNarrowRaw
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]);
}

var inputHeader = Css.style(/* :: */[
      Css.marginBottom(Css.px(0)),
      /* :: */[
        Css.marginTop(Css.px(5)),
        /* :: */[
          Css.fontWeight(700),
          /* [] */0
        ]
      ]
    ]);

var inputField = Css.style(/* :: */[
      Css.margin4(Css.px(10), Css.px(0), Css.px(10), Css.px(0)),
      /* :: */[
        Css.padding2(Css.px(5), Css.px(5)),
        /* [] */0
      ]
    ]);

var someLink = Css.style(/* :: */[
      Css.fontSize(Theme.smallFontSize),
      /* :: */[
        Css.cursor(/* pointer */-786317123),
        /* :: */[
          Css.margin2(Css.px(5), Css.px(0)),
          /* [] */0
        ]
      ]
    ]);

var smallArrow = Css.style(/* :: */[
      Css.fontSize(Theme.smallFontSize),
      /* :: */[
        Css.margin2(Css.px(0), Css.px(8)),
        /* :: */[
          Css.transform(/* `scale */[
                -120664438,
                /* tuple */[
                  1.2,
                  1.2
                ]
              ]),
          /* [] */0
        ]
      ]
    ]);

var infoIcon = Css.style(/* :: */[
      Css.margin2(Css.px(0), Css.px(8)),
      /* [] */0
    ]);

var runnerIconBox = Css.style(/* :: */[
      Css.position(/* absolute */-1013592457),
      /* :: */[
        Css.left(Css.px(0)),
        /* :: */[
          Css.top(Css.px(8)),
          /* :: */[
            Css.cursor(/* pointer */-786317123),
            /* :: */[
              Css.margin4(Css.px(0), Css.px(0), Css.px(0), Css.px(0)),
              /* [] */0
            ]
          ]
        ]
      ]
    ]);

var runnerIcon = Css.style(/* :: */[
      Css.margin2(Css.px(0), Css.px(8)),
      /* [] */0
    ]);

var Styles = /* module */[
  /* flexList */flexList,
  /* mapElement */mapElement,
  /* headBox */headBox,
  /* contentBox */contentBox,
  /* infoHeader */infoHeader,
  /* infoHeaderH1 */infoHeaderH1,
  /* infoHeaderH4 */infoHeaderH4,
  /* infoButton */infoButton,
  /* workoutContainer */workoutContainer,
  /* workoutHeaderBox */workoutHeaderBox,
  /* workoutHeaderMiddleEl */workoutHeaderMiddleEl,
  /* workoutNameHeader */workoutNameHeader,
  /* pairBox */pairBox,
  /* initialBodyFrame */initialBodyFrame,
  /* initialBodyFrameBox */initialBodyFrameBox,
  /* initialBody */initialBody,
  /* initialBodyImgContainer */initialBodyImgContainer,
  /* hiddenImgContainer */hiddenImgContainer,
  /* imgType */imgType,
  /* initialBodyImg */initialBodyImg,
  /* horizonBox */horizonBox,
  /* horizonBoxEl */horizonBoxEl,
  /* smallerGreenSecondaryButton */smallerGreenSecondaryButton,
  /* smallerRedSecondaryButton */smallerRedSecondaryButton,
  /* inputHeader */inputHeader,
  /* inputField */inputField,
  /* someLink */someLink,
  /* smallArrow */smallArrow,
  /* infoIcon */infoIcon,
  /* runnerIconBox */runnerIconBox,
  /* runnerIcon */runnerIcon
];

function convToInt(theString) {
  try {
    return Caml_format.caml_int_of_string(theString);
  }
  catch (raw_exn){
    var exn = Js_exn.internalToOCamlException(raw_exn);
    if (exn[0] === Caml_builtin_exceptions.failure) {
      console.log("Issue with int conversion in workout configuration component");
      return 2;
    } else {
      throw exn;
    }
  }
}

function text(prim) {
  return prim;
}

var component = ReasonReact.reducerComponent("WorkoutConfig");

function plc(exId) {
  var res = /* int array */[
    0,
    0,
    0
  ];
  var match = Caml_array.caml_array_get(Caml_array.caml_array_get(Seed.exerciseImagesCount, exId - 1 | 0), 0);
  if (match !== 2) {
    Caml_array.caml_array_set(res, 0, 3);
  } else {
    Caml_array.caml_array_set(res, 0, 2);
  }
  var match$1 = Caml_array.caml_array_get(Caml_array.caml_array_get(Seed.exerciseImagesCount, exId - 1 | 0), 1);
  if (match$1 !== 2) {
    Caml_array.caml_array_set(res, 1, 3);
  } else {
    Caml_array.caml_array_set(res, 1, 2);
  }
  var match$2 = Caml_array.caml_array_get(Caml_array.caml_array_get(Seed.exerciseImagesCount, exId - 1 | 0), 2);
  var switcher = match$2 - 2 | 0;
  if (switcher > 2 || switcher < 0) {
    Caml_array.caml_array_set(res, 2, 6);
  } else {
    switch (switcher) {
      case 0 : 
          Caml_array.caml_array_set(res, 2, 2);
          break;
      case 1 : 
          Caml_array.caml_array_set(res, 2, 3);
          break;
      case 2 : 
          Caml_array.caml_array_set(res, 2, 4);
          break;
      
    }
  }
  console.log("preset", res);
  return res;
}

function make(week, workout, _) {
  var newrecord = component.slice();
  newrecord[/* didMount */4] = (function (self) {
      var newrecord = self[/* state */2].slice();
      return /* Update */Block.__(0, [(newrecord[/* levels */2] = Caml_array.caml_array_get(self[/* state */2][/* allLevels */3], self[/* state */2][/* workoutIndex */0]), newrecord)]);
    });
  newrecord[/* render */9] = (function (self) {
      return React.createElement("div", {
                  className: flexList
                }, React.createElement("div", {
                      className: headBox
                    }, React.createElement("div", {
                          className: runnerIconBox
                        }, React.createElement("img", {
                              className: runnerIcon,
                              alt: "runner",
                              src: Jogging_iconSvg
                            })), React.createElement("h1", {
                          className: infoHeaderH1
                        }, "Workout " + workout), React.createElement("h4", {
                          className: infoHeaderH4
                        }, "Wähle deinen Schwierigkeitsgrad")), React.createElement("div", {
                      className: contentBox
                    }, $$Array.mapi((function (index, _) {
                            var exId = Caml_array.caml_array_get(self[/* state */2][/* currentWorkoutExercisesIds */8], index);
                            var match = +(Caml_array.caml_array_get(self[/* state */2][/* blockLoaded */6], 0) === 0);
                            var block12 = React.createElement("div", {
                                  className: initialBodyFrame
                                }, match !== 0 ? React.createElement("div", {
                                        className: initialBody
                                      }, React.createElement("div", {
                                            className: initialBodyImgContainer
                                          }, React.createElement("div", {
                                                className: imgType
                                              }, "leicht"), React.createElement("img", {
                                                className: initialBodyImg,
                                                src: "/" + (String(exId) + "_l1_a.jpg")
                                              })), React.createElement("div", {
                                            className: initialBodyImgContainer
                                          }, React.createElement("img", {
                                                className: initialBodyImg,
                                                src: "/" + (String(exId) + "_l1_b.jpg")
                                              }))) : null, React.createElement("div", {
                                      className: hiddenImgContainer
                                    }, React.createElement("div", {
                                          className: initialBodyImgContainer
                                        }, React.createElement("img", {
                                              className: initialBodyImg,
                                              src: "/" + (String(exId) + "_l1_a.jpg"),
                                              onLoad: (function () {
                                                  return Curry._1(self[/* send */4], /* Loaded */Block.__(3, [0]));
                                                })
                                            })), React.createElement("div", {
                                          className: initialBodyImgContainer
                                        }, React.createElement("img", {
                                              className: initialBodyImg,
                                              src: "/" + (String(exId) + "_l1_b.jpg"),
                                              onLoad: (function () {
                                                  return Curry._1(self[/* send */4], /* Loaded */Block.__(3, [0]));
                                                })
                                            }))));
                            var match$1 = +(Caml_array.caml_array_get(self[/* state */2][/* blockLoaded */6], 0) === 0);
                            var block13 = React.createElement("div", {
                                  className: initialBodyFrame
                                }, match$1 !== 0 ? React.createElement("div", {
                                        className: initialBody
                                      }, React.createElement("div", {
                                            className: initialBodyImgContainer
                                          }, React.createElement("div", {
                                                className: imgType
                                              }, "leicht"), React.createElement("img", {
                                                className: initialBodyImg,
                                                src: "/" + (String(exId) + "_l1_a.jpg")
                                              })), React.createElement("div", {
                                            className: initialBodyImgContainer
                                          }, React.createElement("img", {
                                                className: initialBodyImg,
                                                src: "/" + (String(exId) + "_l1_b.jpg")
                                              })), React.createElement("div", {
                                            className: initialBodyImgContainer
                                          }, React.createElement("img", {
                                                className: initialBodyImg,
                                                src: "/" + (String(exId) + "_l1_c.jpg")
                                              }))) : null, React.createElement("div", {
                                      className: hiddenImgContainer
                                    }, React.createElement("div", {
                                          className: initialBodyImgContainer
                                        }, React.createElement("img", {
                                              className: initialBodyImg,
                                              src: "/" + (String(exId) + "_l1_a.jpg"),
                                              onLoad: (function () {
                                                  return Curry._1(self[/* send */4], /* Loaded */Block.__(3, [0]));
                                                })
                                            })), React.createElement("div", {
                                          className: initialBodyImgContainer
                                        }, React.createElement("img", {
                                              className: initialBodyImg,
                                              src: "/" + (String(exId) + "_l1_b.jpg"),
                                              onLoad: (function () {
                                                  return Curry._1(self[/* send */4], /* Loaded */Block.__(3, [0]));
                                                })
                                            })), React.createElement("div", {
                                          className: initialBodyImgContainer
                                        }, React.createElement("img", {
                                              className: initialBodyImg,
                                              src: "/" + (String(exId) + "_l1_c.jpg"),
                                              onLoad: (function () {
                                                  return Curry._1(self[/* send */4], /* Loaded */Block.__(3, [0]));
                                                })
                                            }))));
                            var match$2 = +(Caml_array.caml_array_get(self[/* state */2][/* blockLoaded */6], 1) === 0);
                            var block22 = React.createElement("div", {
                                  className: initialBodyFrame
                                }, match$2 !== 0 ? React.createElement("div", {
                                        className: initialBody
                                      }, React.createElement("div", {
                                            className: initialBodyImgContainer
                                          }, React.createElement("div", {
                                                className: imgType
                                              }, "mittel"), React.createElement("img", {
                                                className: initialBodyImg,
                                                src: "/" + (String(Caml_array.caml_array_get(self[/* state */2][/* currentWorkoutExercisesIds */8], index)) + "_l2_a.jpg")
                                              })), React.createElement("div", {
                                            className: initialBodyImgContainer
                                          }, React.createElement("img", {
                                                className: initialBodyImg,
                                                src: "/" + (String(exId) + "_l2_b.jpg")
                                              }))) : null, React.createElement("div", {
                                      className: hiddenImgContainer
                                    }, React.createElement("div", {
                                          className: initialBodyImgContainer
                                        }, React.createElement("img", {
                                              className: initialBodyImg,
                                              src: "/" + (String(Caml_array.caml_array_get(self[/* state */2][/* currentWorkoutExercisesIds */8], index)) + "_l2_a.jpg"),
                                              onLoad: (function () {
                                                  return Curry._1(self[/* send */4], /* Loaded */Block.__(3, [1]));
                                                })
                                            })), React.createElement("div", {
                                          className: initialBodyImgContainer
                                        }, React.createElement("img", {
                                              className: initialBodyImg,
                                              src: "/" + (String(exId) + "_l2_b.jpg"),
                                              onLoad: (function () {
                                                  return Curry._1(self[/* send */4], /* Loaded */Block.__(3, [1]));
                                                })
                                            }))));
                            var match$3 = +(Caml_array.caml_array_get(self[/* state */2][/* blockLoaded */6], 1) === 0);
                            var block23 = React.createElement("div", {
                                  className: initialBodyFrame
                                }, match$3 !== 0 ? React.createElement("div", {
                                        className: initialBody
                                      }, React.createElement("div", {
                                            className: initialBodyImgContainer
                                          }, React.createElement("div", {
                                                className: imgType
                                              }, "mittel"), React.createElement("img", {
                                                className: initialBodyImg,
                                                src: "/" + (String(Caml_array.caml_array_get(self[/* state */2][/* currentWorkoutExercisesIds */8], index)) + "_l2_a.jpg")
                                              })), React.createElement("div", {
                                            className: initialBodyImgContainer
                                          }, React.createElement("img", {
                                                className: initialBodyImg,
                                                src: "/" + (String(exId) + "_l2_b.jpg")
                                              })), React.createElement("div", {
                                            className: initialBodyImgContainer
                                          }, React.createElement("img", {
                                                className: initialBodyImg,
                                                src: "/" + (String(exId) + "_l2_c.jpg")
                                              }))) : null, React.createElement("div", {
                                      className: hiddenImgContainer
                                    }, React.createElement("div", {
                                          className: initialBodyImgContainer
                                        }, React.createElement("img", {
                                              className: initialBodyImg,
                                              src: "/" + (String(Caml_array.caml_array_get(self[/* state */2][/* currentWorkoutExercisesIds */8], index)) + "_l2_a.jpg"),
                                              onLoad: (function () {
                                                  return Curry._1(self[/* send */4], /* Loaded */Block.__(3, [1]));
                                                })
                                            })), React.createElement("div", {
                                          className: initialBodyImgContainer
                                        }, React.createElement("img", {
                                              className: initialBodyImg,
                                              src: "/" + (String(exId) + "_l2_b.jpg"),
                                              onLoad: (function () {
                                                  return Curry._1(self[/* send */4], /* Loaded */Block.__(3, [1]));
                                                })
                                            })), React.createElement("div", {
                                          className: initialBodyImgContainer
                                        }, React.createElement("img", {
                                              className: initialBodyImg,
                                              src: "/" + (String(exId) + "_l2_c.jpg"),
                                              onLoad: (function () {
                                                  return Curry._1(self[/* send */4], /* Loaded */Block.__(3, [1]));
                                                })
                                            }))));
                            var match$4 = +(Caml_array.caml_array_get(self[/* state */2][/* blockLoaded */6], 2) === 0);
                            var block32 = React.createElement("div", {
                                  className: initialBodyFrame
                                }, match$4 !== 0 ? React.createElement("div", {
                                        className: initialBody
                                      }, React.createElement("div", {
                                            className: initialBodyImgContainer
                                          }, React.createElement("div", {
                                                className: imgType
                                              }, "schwer"), React.createElement("img", {
                                                className: initialBodyImg,
                                                src: "/" + (String(exId) + "_l3_a.jpg")
                                              })), React.createElement("div", {
                                            className: initialBodyImgContainer
                                          }, React.createElement("img", {
                                                className: initialBodyImg,
                                                src: "/" + (String(exId) + "_l3_b.jpg")
                                              }))) : null, React.createElement("div", {
                                      className: hiddenImgContainer
                                    }, React.createElement("div", {
                                          className: initialBodyImgContainer
                                        }, React.createElement("img", {
                                              className: initialBodyImg,
                                              src: "/" + (String(exId) + "_l3_a.jpg"),
                                              onLoad: (function () {
                                                  return Curry._1(self[/* send */4], /* Loaded */Block.__(3, [2]));
                                                })
                                            })), React.createElement("div", {
                                          className: initialBodyImgContainer
                                        }, React.createElement("img", {
                                              className: initialBodyImg,
                                              src: "/" + (String(exId) + "_l3_b.jpg"),
                                              onLoad: (function () {
                                                  return Curry._1(self[/* send */4], /* Loaded */Block.__(3, [2]));
                                                })
                                            }))));
                            var match$5 = +(Caml_array.caml_array_get(self[/* state */2][/* blockLoaded */6], 2) === 0);
                            var block33 = React.createElement("div", {
                                  className: initialBodyFrame
                                }, match$5 !== 0 ? React.createElement("div", {
                                        className: initialBody
                                      }, React.createElement("div", {
                                            className: initialBodyImgContainer
                                          }, React.createElement("div", {
                                                className: imgType
                                              }, "schwer"), React.createElement("img", {
                                                className: initialBodyImg,
                                                src: "/" + (String(exId) + "_l3_a.jpg")
                                              })), React.createElement("div", {
                                            className: initialBodyImgContainer
                                          }, React.createElement("img", {
                                                className: initialBodyImg,
                                                src: "/" + (String(exId) + "_l3_b.jpg")
                                              })), React.createElement("div", {
                                            className: initialBodyImgContainer
                                          }, React.createElement("img", {
                                                className: initialBodyImg,
                                                src: "/" + (String(exId) + "_l3_c.jpg")
                                              }))) : null, React.createElement("div", {
                                      className: hiddenImgContainer
                                    }, React.createElement("div", {
                                          className: initialBodyImgContainer
                                        }, React.createElement("img", {
                                              className: initialBodyImg,
                                              src: "/" + (String(exId) + "_l3_a.jpg"),
                                              onLoad: (function () {
                                                  return Curry._1(self[/* send */4], /* Loaded */Block.__(3, [2]));
                                                })
                                            })), React.createElement("div", {
                                          className: initialBodyImgContainer
                                        }, React.createElement("img", {
                                              className: initialBodyImg,
                                              src: "/" + (String(exId) + "_l3_b.jpg"),
                                              onLoad: (function () {
                                                  return Curry._1(self[/* send */4], /* Loaded */Block.__(3, [2]));
                                                })
                                            })), React.createElement("div", {
                                          className: initialBodyImgContainer
                                        }, React.createElement("img", {
                                              className: initialBodyImg,
                                              src: "/" + (String(exId) + "_l3_c.jpg"),
                                              onLoad: (function () {
                                                  return Curry._1(self[/* send */4], /* Loaded */Block.__(3, [2]));
                                                })
                                            }))));
                            var match$6 = +(Caml_array.caml_array_get(self[/* state */2][/* blockLoaded */6], 2) === 0);
                            var block34 = React.createElement("div", {
                                  className: initialBodyFrame
                                }, match$6 !== 0 ? React.createElement("div", {
                                        className: initialBodyFrameBox
                                      }, React.createElement("div", {
                                            className: initialBody
                                          }, React.createElement("div", {
                                                className: initialBodyImgContainer
                                              }, React.createElement("div", {
                                                    className: imgType
                                                  }, "schwer"), React.createElement("img", {
                                                    className: initialBodyImg,
                                                    src: "/" + (String(exId) + "_l3_a.jpg")
                                                  })), React.createElement("div", {
                                                className: initialBodyImgContainer
                                              }, React.createElement("img", {
                                                    className: initialBodyImg,
                                                    src: "/" + (String(exId) + "_l3_b.jpg")
                                                  }))), React.createElement("div", {
                                            className: initialBody
                                          }, React.createElement("div", {
                                                className: initialBodyImgContainer
                                              }, React.createElement("img", {
                                                    className: initialBodyImg,
                                                    src: "/" + (String(exId) + "_l3_c.jpg")
                                                  })), React.createElement("div", {
                                                className: initialBodyImgContainer
                                              }, React.createElement("img", {
                                                    className: initialBodyImg,
                                                    src: "/" + (String(exId) + "_l3_d.jpg")
                                                  })))) : null, React.createElement("div", {
                                      className: hiddenImgContainer
                                    }, React.createElement("div", {
                                          className: initialBody
                                        }, React.createElement("div", {
                                              className: initialBodyImgContainer
                                            }, React.createElement("img", {
                                                  className: initialBodyImg,
                                                  src: "/" + (String(exId) + "_l3_a.jpg"),
                                                  onLoad: (function () {
                                                      return Curry._1(self[/* send */4], /* Loaded */Block.__(3, [2]));
                                                    })
                                                })), React.createElement("div", {
                                              className: initialBodyImgContainer
                                            }, React.createElement("img", {
                                                  className: initialBodyImg,
                                                  src: "/" + (String(exId) + "_l3_b.jpg"),
                                                  onLoad: (function () {
                                                      return Curry._1(self[/* send */4], /* Loaded */Block.__(3, [2]));
                                                    })
                                                }))), React.createElement("div", {
                                          className: initialBody
                                        }, React.createElement("div", {
                                              className: initialBodyImgContainer
                                            }, React.createElement("img", {
                                                  className: initialBodyImg,
                                                  src: "/" + (String(exId) + "_l3_c.jpg"),
                                                  onLoad: (function () {
                                                      return Curry._1(self[/* send */4], /* Loaded */Block.__(3, [2]));
                                                    })
                                                })), React.createElement("div", {
                                              className: initialBodyImgContainer
                                            }, React.createElement("img", {
                                                  className: initialBodyImg,
                                                  src: "/" + (String(exId) + "_l3_d.jpg"),
                                                  onLoad: (function () {
                                                      return Curry._1(self[/* send */4], /* Loaded */Block.__(3, [2]));
                                                    })
                                                })))));
                            var match$7 = +(Caml_array.caml_array_get(self[/* state */2][/* blockLoaded */6], 2) === 0);
                            var block36 = React.createElement("div", {
                                  className: initialBodyFrame
                                }, match$7 !== 0 ? React.createElement("div", {
                                        className: initialBodyFrameBox
                                      }, React.createElement("div", {
                                            className: initialBody
                                          }, React.createElement("div", {
                                                className: initialBodyImgContainer
                                              }, React.createElement("div", {
                                                    className: imgType
                                                  }, "schwer"), React.createElement("img", {
                                                    className: initialBodyImg,
                                                    src: "/" + (String(exId) + "_l3_a.jpg")
                                                  })), React.createElement("div", {
                                                className: initialBodyImgContainer
                                              }, React.createElement("img", {
                                                    className: initialBodyImg,
                                                    src: "/" + (String(exId) + "_l3_b.jpg")
                                                  })), React.createElement("div", {
                                                className: initialBodyImgContainer
                                              }, React.createElement("img", {
                                                    className: initialBodyImg,
                                                    src: "/" + (String(exId) + "_l3_c.jpg")
                                                  }))), React.createElement("div", {
                                            className: initialBody
                                          }, React.createElement("div", {
                                                className: initialBodyImgContainer
                                              }, React.createElement("img", {
                                                    className: initialBodyImg,
                                                    src: "/" + (String(exId) + "_l3_d.jpg")
                                                  })), React.createElement("div", {
                                                className: initialBodyImgContainer
                                              }, React.createElement("img", {
                                                    className: initialBodyImg,
                                                    src: "/" + (String(exId) + "_l3_e.jpg")
                                                  })), React.createElement("div", {
                                                className: initialBodyImgContainer
                                              }, React.createElement("img", {
                                                    className: initialBodyImg,
                                                    src: "/" + (String(exId) + "_l3_f.jpg")
                                                  })))) : null, React.createElement("div", {
                                      className: hiddenImgContainer
                                    }, React.createElement("div", {
                                          className: initialBody
                                        }, React.createElement("div", {
                                              className: initialBodyImgContainer
                                            }, React.createElement("img", {
                                                  className: initialBodyImg,
                                                  src: "/" + (String(exId) + "_l3_a.jpg"),
                                                  onLoad: (function () {
                                                      return Curry._1(self[/* send */4], /* Loaded */Block.__(3, [2]));
                                                    })
                                                })), React.createElement("div", {
                                              className: initialBodyImgContainer
                                            }, React.createElement("img", {
                                                  className: initialBodyImg,
                                                  src: "/" + (String(exId) + "_l3_b.jpg"),
                                                  onLoad: (function () {
                                                      return Curry._1(self[/* send */4], /* Loaded */Block.__(3, [2]));
                                                    })
                                                })), React.createElement("div", {
                                              className: initialBodyImgContainer
                                            }, React.createElement("img", {
                                                  className: initialBodyImg,
                                                  src: "/" + (String(exId) + "_l3_c.jpg"),
                                                  onLoad: (function () {
                                                      return Curry._1(self[/* send */4], /* Loaded */Block.__(3, [2]));
                                                    })
                                                }))), React.createElement("div", {
                                          className: initialBody
                                        }, React.createElement("div", {
                                              className: initialBodyImgContainer
                                            }, React.createElement("img", {
                                                  className: initialBodyImg,
                                                  src: "/" + (String(exId) + "_l3_d.jpg"),
                                                  onLoad: (function () {
                                                      return Curry._1(self[/* send */4], /* Loaded */Block.__(3, [2]));
                                                    })
                                                })), React.createElement("div", {
                                              className: initialBodyImgContainer
                                            }, React.createElement("img", {
                                                  className: initialBodyImg,
                                                  src: "/" + (String(exId) + "_l3_e.jpg"),
                                                  onLoad: (function () {
                                                      return Curry._1(self[/* send */4], /* Loaded */Block.__(3, [2]));
                                                    })
                                                })), React.createElement("div", {
                                              className: initialBodyImgContainer
                                            }, React.createElement("img", {
                                                  className: initialBodyImg,
                                                  src: "/" + (String(exId) + "_l3_f.jpg"),
                                                  onLoad: (function () {
                                                      return Curry._1(self[/* send */4], /* Loaded */Block.__(3, [2]));
                                                    })
                                                })))));
                            var match$8 = Caml_array.caml_array_get(self[/* state */2][/* showDetails */5], index);
                            var tmp;
                            if (match$8 !== 0) {
                              var match$9 = Caml_array.caml_array_get(Caml_array.caml_array_get(Seed.exerciseImagesCount, exId - 1 | 0), 0);
                              var match$10 = Caml_array.caml_array_get(Caml_array.caml_array_get(Seed.exerciseImagesCount, exId - 1 | 0), 1);
                              var match$11 = Caml_array.caml_array_get(Caml_array.caml_array_get(Seed.exerciseImagesCount, exId - 1 | 0), 2);
                              var switcher = match$11 - 2 | 0;
                              var tmp$1;
                              if (switcher > 2 || switcher < 0) {
                                tmp$1 = block36;
                              } else {
                                switch (switcher) {
                                  case 0 : 
                                      tmp$1 = block32;
                                      break;
                                  case 1 : 
                                      tmp$1 = block33;
                                      break;
                                  case 2 : 
                                      tmp$1 = block34;
                                      break;
                                  
                                }
                              }
                              tmp = React.createElement("div", {
                                    className: flexList
                                  }, match$9 !== 2 ? block13 : block12, match$10 !== 2 ? block23 : block22, tmp$1);
                            } else {
                              tmp = null;
                            }
                            var match$12 = +(1 !== Caml_array.caml_array_get(self[/* state */2][/* levels */2], index));
                            var match$13 = +(2 !== Caml_array.caml_array_get(self[/* state */2][/* levels */2], index));
                            var match$14 = +(3 !== Caml_array.caml_array_get(self[/* state */2][/* levels */2], index));
                            return React.createElement("div", {
                                        key: String(index),
                                        className: mapElement
                                      }, React.createElement("div", {
                                            className: workoutContainer
                                          }, React.createElement("div", {
                                                className: workoutHeaderBox
                                              }, React.createElement("div", {
                                                    className: workoutHeaderMiddleEl
                                                  }, React.createElement("h4", {
                                                        className: workoutNameHeader
                                                      }, Caml_array.caml_array_get(self[/* state */2][/* currentWorkoutExercises */7], index)), React.createElement("div", {
                                                        className: pairBox
                                                      }, "Übungspaar ", Caml_array.caml_array_get(self[/* state */2][/* pair */4], index) + "/3")), React.createElement("div", {
                                                    className: infoButton,
                                                    onClick: (function () {
                                                        return Curry._1(self[/* send */4], /* ToggleDetails */Block.__(1, [
                                                                      index,
                                                                      exId
                                                                    ]));
                                                      })
                                                  }, React.createElement("img", {
                                                        className: infoIcon,
                                                        alt: "info",
                                                        src: Info_iconSvg
                                                      }))), tmp, React.createElement("div", {
                                                className: horizonBox
                                              }, match$12 !== 0 ? React.createElement("div", {
                                                      className: smallerRedSecondaryButton(/* () */0),
                                                      onClick: (function () {
                                                          return Curry._1(self[/* send */4], /* SetLevel */Block.__(0, [
                                                                        1,
                                                                        index
                                                                      ]));
                                                        })
                                                    }, "leicht") : React.createElement("div", {
                                                      className: smallerGreenSecondaryButton(/* () */0),
                                                      onClick: (function () {
                                                          return Curry._1(self[/* send */4], /* SetLevel */Block.__(0, [
                                                                        1,
                                                                        index
                                                                      ]));
                                                        })
                                                    }, "leicht"), match$13 !== 0 ? React.createElement("div", {
                                                      className: smallerRedSecondaryButton(/* () */0),
                                                      onClick: (function () {
                                                          return Curry._1(self[/* send */4], /* SetLevel */Block.__(0, [
                                                                        2,
                                                                        index
                                                                      ]));
                                                        })
                                                    }, "mittel") : React.createElement("div", {
                                                      className: smallerGreenSecondaryButton(/* () */0),
                                                      onClick: (function () {
                                                          return Curry._1(self[/* send */4], /* SetLevel */Block.__(0, [
                                                                        2,
                                                                        index
                                                                      ]));
                                                        })
                                                    }, "mittel"), match$14 !== 0 ? React.createElement("div", {
                                                      className: smallerRedSecondaryButton(/* () */0),
                                                      onClick: (function () {
                                                          return Curry._1(self[/* send */4], /* SetLevel */Block.__(0, [
                                                                        3,
                                                                        index
                                                                      ]));
                                                        })
                                                    }, "schwer") : React.createElement("div", {
                                                      className: smallerGreenSecondaryButton(/* () */0),
                                                      onClick: (function () {
                                                          return Curry._1(self[/* send */4], /* SetLevel */Block.__(0, [
                                                                        3,
                                                                        index
                                                                      ]));
                                                        })
                                                    }, "schwer"))));
                          }), self[/* state */2][/* levels */2]), React.createElement("button", {
                          className: Theme.greenButton(/* () */0),
                          onClick: (function () {
                              return Curry._1(self[/* send */4], /* StoreResults */0);
                            })
                        }, "Weiter", React.createElement("img", {
                              className: smallArrow,
                              alt: "arrow",
                              src: Cta_arrowSvg
                            }))));
    });
  newrecord[/* initialState */10] = (function () {
      return /* record */[
              /* workoutIndex */Caml_int32.imul(Caml_format.caml_int_of_string(week) - 1 | 0, 6) + (Caml_format.caml_int_of_string(workout) - 1 | 0) | 0,
              /* workoutConfigured : false */0,
              /* levels : array */[
                1,
                1,
                1,
                1,
                1,
                1
              ],
              /* allLevels */Network.pullLevelConfig(/* () */0),
              /* pair : array */[
                "1",
                "1",
                "2",
                "2",
                "3",
                "3"
              ],
              /* showDetails : array */[
                /* false */0,
                /* false */0,
                /* false */0,
                /* false */0,
                /* false */0,
                /* false */0
              ],
              /* blockLoaded : int array */[
                0,
                0,
                0
              ],
              /* currentWorkoutExercises */Seed.getWorkoutTitles(week, workout),
              /* currentWorkoutExercisesIds */Seed.getWorkoutIds(week, workout),
              /* hide1 : false */0,
              /* hide2 : false */0,
              /* hide3 : false */0
            ];
    });
  newrecord[/* reducer */12] = (function (action, state) {
      if (typeof action === "number") {
        var newrecord = state.slice();
        return /* UpdateWithSideEffects */Block.__(3, [
                  (newrecord[/* workoutConfigured */1] = /* true */1, newrecord),
                  (function () {
                      Network.safeLevelSettingsToLs(state[/* levels */2], state[/* allLevels */3], state[/* workoutIndex */0]);
                      return ReasonReact.Router[/* push */0]("/week/" + (week + ("/workout/" + (workout + "/1/1/2"))));
                    })
                ]);
      } else {
        switch (action.tag | 0) {
          case 0 : 
              var newL = state[/* levels */2];
              Caml_array.caml_array_set(newL, action[1], action[0]);
              var newrecord$1 = state.slice();
              return /* Update */Block.__(0, [(newrecord$1[/* levels */2] = newL, newrecord$1)]);
          case 1 : 
              var item = action[0];
              var presetLoadedCount = plc(action[1]);
              var showDetailsNew = $$Array.mapi((function (index, oldEntry) {
                      var match = +(index === item);
                      if (match !== 0) {
                        return 1 - oldEntry;
                      } else {
                        return /* false */0;
                      }
                    }), state[/* showDetails */5]);
              var newrecord$2 = state.slice();
              return /* Update */Block.__(0, [(newrecord$2[/* showDetails */5] = showDetailsNew, newrecord$2[/* blockLoaded */6] = presetLoadedCount, newrecord$2)]);
          case 2 : 
              var item$1 = action[0];
              console.log("hiding: ", item$1);
              if (item$1 !== 1) {
                if (item$1 !== 2) {
                  var newrecord$3 = state.slice();
                  return /* Update */Block.__(0, [(newrecord$3[/* hide3 */11] = /* true */1, newrecord$3)]);
                } else {
                  var newrecord$4 = state.slice();
                  return /* Update */Block.__(0, [(newrecord$4[/* hide2 */10] = /* true */1, newrecord$4)]);
                }
              } else {
                var newrecord$5 = state.slice();
                return /* Update */Block.__(0, [(newrecord$5[/* hide1 */9] = /* true */1, newrecord$5)]);
              }
          case 3 : 
              var pos = action[0];
              console.log("Loaded");
              var bl = state[/* blockLoaded */6];
              Caml_array.caml_array_set(bl, pos, Caml_array.caml_array_get(bl, pos) - 1 | 0);
              var newrecord$6 = state.slice();
              return /* Update */Block.__(0, [(newrecord$6[/* blockLoaded */6] = bl, newrecord$6)]);
          
        }
      }
    });
  return newrecord;
}

exports.Styles = Styles;
exports.convToInt = convToInt;
exports.text = text;
exports.component = component;
exports.plc = plc;
exports.make = make;
/* flexList Not a pure module */



//////////////////
// WEBPACK FOOTER
// ./src/workoutConfig.re
// module id = 156
// module chunks = 0